import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
  },
  searchFields: {
    marginTop: theme.spacing(4),
    width: '100%',
  },
  field: {
    marginBottom: theme.spacing(2),
    width: '100%',
    '& fieldset': {
      borderColor: theme.palette.colors.border,
    },
    '& label': {
      position: 'relative',
      transform: 'none',
      fontSize: 12,
      marginBottom: theme.spacing(1),
      color: '#90A4AE',
    },
    '& input': {
      height: '100%',
      padding: [0, 14],
    },
    [theme.breakpoints.up('mobile')]: {
      width: '30%',
      minWidth: 150,
      marginRight: theme.spacing(3),
      '&:last-child': {
        marginRight: 0,
      },
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentLoanOfficers/components/Search/useStyles.js